import { AxiosInstance } from 'axios';
import { AppEntitlementEnum, AppPermissionEnum } from '@/compiler/types';
import baseAxios from '@/helpers/forms/axios';
import { MerchantUserRole } from '../merchants';
import { ServiceProviderUserRole } from '../serviceProviders';

export type PlatformUserRole = 'developer' | 'partner';

interface NarrativeApiReturn {
    fetchCurrentPermissions: () => Promise<{ [key in AppPermissionEnum]: boolean }>
    fetchCurrentEntitlements: () => Promise<AppEntitlementEnum[]>
    fetchCurrentUserRoles: () => Promise<{ serviceProvider: ServiceProviderUserRole[]; merchant: MerchantUserRole[]; platform: PlatformUserRole[] }>
    fetchCurrentFeatures: () => Promise<AppEntitlementEnum[]>
}

export default (axios: AxiosInstance = baseAxios): NarrativeApiReturn => {
    const fetchCurrentEntitlements = async (): Promise<AppEntitlementEnum[]> => {
        const response = await axios.get<AppEntitlementEnum[]>('/api/narrative/entitlements');

        return response.data;
    };

    return {
        fetchCurrentPermissions: async (): Promise<{ [key in AppPermissionEnum]: boolean }> => {
            const response = await axios.get<{ [key in AppPermissionEnum]: boolean }>('/api/narrative/permissions');

            return response.data;
        },

        fetchCurrentEntitlements,

        fetchCurrentUserRoles: async (): Promise<{ serviceProvider: ServiceProviderUserRole[]; merchant: MerchantUserRole[]; platform: PlatformUserRole[]; }> => {
            const response = await axios.get<{
                serviceProvider: ServiceProviderUserRole[]
                merchant: MerchantUserRole[]
                platform: PlatformUserRole[]
            }>('/api/narrative/roles');

            return response.data;
        },

        fetchCurrentFeatures: fetchCurrentEntitlements,
    };
};
